import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52373c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-tabs"
}
const _hoisted_2 = { class: "filter-header" }
const _hoisted_3 = { class: "left-section" }
const _hoisted_4 = {
  key: 0,
  class: "signal-tabs"
}
const _hoisted_5 = {
  key: 1,
  class: "update-time"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_7 = { class: "time-text" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_11 = { class: "stock-count-value" }
const _hoisted_12 = {
  key: 2,
  class: "update-time"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_14 = { class: "time-text" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_18 = { class: "stock-count-value" }
const _hoisted_19 = {
  key: 3,
  class: "history-date-select"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "选择日期：", -1))
const _hoisted_21 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_23 = { class: "stock-count-value" }
const _hoisted_24 = { class: "actions" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 只看自选 ")
const _hoisted_26 = {
  key: 1,
  class: "stock-search-wrapper"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode("> ")
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "stock-code" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "stock-market" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "filter-content-popup" }
const _hoisted_34 = { class: "filter-scroll-area" }
const _hoisted_35 = { class: "filter-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "趋势势能", -1))
const _hoisted_37 = { class: "filter-options" }
const _hoisted_38 = { class: "filter-group" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "资金标尺", -1))
const _hoisted_40 = { class: "filter-options" }
const _hoisted_41 = { class: "filter-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "题材追踪", -1))
const _hoisted_43 = { class: "filter-options" }
const _hoisted_44 = { class: "filter-actions" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "↻", -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 恢复默认 ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_48 = ["src"]
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 筛选 ")
const _hoisted_50 = {
  key: 1,
  class: "selected-stock-info"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "入选股票：", -1))
const _hoisted_52 = { class: "info-count" }
const _hoisted_53 = { class: "info-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter-panel", _ctx.theme])
  }, [
    (_ctx.isMengzhuTrend && _ctx.mainTabs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'signalPool' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMainTabChange('signalPool')))
          }, _toDisplayString(_ctx.mainTabs.signalPool?.label || '信号池'), 3),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'hotCases' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMainTabChange('hotCases')))
          }, _toDisplayString(_ctx.mainTabs.hotCases?.label || '近30天热门案例'), 3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.signalType === 'latest' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSignalTypeChange('latest')))
              }, _toDisplayString(_ctx.signalTabLabels.latest), 3),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.signalType === 'history' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSignalTypeChange('history')))
              }, _toDisplayString(_ctx.signalTabLabels.history), 3)
            ]))
          : _createCommentVNode("", true),
        (_ctx.signalType === 'latest' && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.updateTime || '--'), 1),
              _createElementVNode("span", {
                class: "refresh-icon",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/Refresh.png'),
                  alt: "刷新"
                }, null, 8, _hoisted_8)
              ]),
              (_ctx.showStockCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.stockCount), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (!_ctx.showHistoryDateSelect && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.updateTime || '--'), 1),
                _createElementVNode("span", {
                  class: "refresh-icon",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/Refresh.png'),
                    alt: "刷新"
                  }, null, 8, _hoisted_15)
                ]),
                (_ctx.showStockCount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.stockCount), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : ((!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_a_select, {
                    value: _ctx.selectedDate,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedDate) = $event)),
                    style: {"width":"160px"},
                    placeholder: "请选择日期",
                    onChange: _ctx.onHistoryDateSelect,
                    dropdownClassName: _ctx.theme === 'dark' ? 'dark-dropdown' : 'light-dropdown'
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateOptions, (date) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: date,
                          value: date
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(date), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange", "dropdownClassName"]),
                  (_ctx.showStockCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.stockCount), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(['only-optional', { active: _ctx.onlyOptional }]),
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleOptional && _ctx.toggleOptional(...args)))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(['checkbox-icon', { active: _ctx.onlyOptional }])
              }, null, 2),
              _hoisted_25
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.showStockSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_a_select, {
                ref: "stockSearchRef",
                value: _ctx.searchStock,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchStock) = $event)),
                "show-search": "",
                placeholder: '搜索个股筹码大师',
                style: {"width":"200px"},
                "show-arrow": false,
                "filter-option": false,
                getPopupContainer: _ctx.getPopupContainer,
                "not-found-content": null,
                open: _ctx.searchDropdownOpen,
                onSearch: _ctx.handleStockSearch,
                onFocus: _ctx.handleSearchFocus,
                onBlur: _ctx.handleSearchBlur,
                onDropdownVisibleChange: _ctx.handleDropdownVisibleChange,
                onSelect: _ctx.handleOptionSelect,
                listHeight: 300,
                virtual: false,
                dropdownClassName: _ctx.theme === 'dark' ? 'dark-dropdown' : 'light-dropdown'
              }, {
                default: _withCtx(() => [
                  _hoisted_27,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.Id,
                      key: item.Id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "stock-option-item",
                          onClick: _withModifiers(($event: any) => (_ctx.handleStockSelect(item)), ["stop"])
                        }, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(item.Code), 1),
                          _createElementVNode("span", {
                            class: "stock-name",
                            title: item.Name
                          }, _toDisplayString(_ctx.formatStockName(item.Name)), 9, _hoisted_30),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(item.MarketCode === 'sh' ? '沪A' : item.MarketCode === 'sz' ? '深A' :
                  item.MarketCode === 'bj' ? '京A' : ''), 1),
                          (_ctx.isShowingHistory)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "history-delete-icon",
                                onClick: _withModifiers(($event: any) => (_ctx.removeFromHistory(item, $event)), ["stop"])
                              }, "×", 8, _hoisted_32))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_28)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "getPopupContainer", "open", "onSearch", "onFocus", "onBlur", "onDropdownVisibleChange", "onSelect", "dropdownClassName"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFilterBtn)
          ? (_openBlock(), _createBlock(_component_a_popover, {
              key: 2,
              visible: _ctx.showFilter,
              placement: "bottomRight",
              overlayClassName: "filter-popover",
              getPopupContainer: _ctx.getPopupContainer
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.macd === 0 }]),
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setFilter('macd', 0)))
                        }, "全部", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.macd === 1 }]),
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setFilter('macd', 1)))
                        }, "强势", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.macd === 2 }]),
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setFilter('macd', 2)))
                        }, "弱势", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.amount === 0 }]),
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setFilter('amount', 0)))
                        }, "全部", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.amount === 1 }]),
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setFilter('amount', 1)))
                        }, "强势", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.amount === 2 }]),
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setFilter('amount', 2)))
                        }, "弱势", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.plate === 0 }]),
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setFilter('plate', 0)))
                        }, "全部", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.plate === 1 }]),
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setFilter('plate', 1)))
                        }, "核心风口", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.plate === 2 }]),
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setFilter('plate', 2)))
                        }, "普通风口", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.plate === 3 }]),
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setFilter('plate', 3)))
                        }, "未入选", 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_a_button, {
                      class: "reset-btn",
                      onClick: _ctx.handleReset
                    }, {
                      default: _withCtx(() => [
                        _hoisted_45,
                        _hoisted_46
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "confirm-btn",
                      onClick: _ctx.handleConfirm
                    }, {
                      default: _withCtx(() => [
                        _hoisted_47
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(['filter-btn', { active: _ctx.isFilterActive }]),
                  onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)), ["stop"]))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.getFilterIcon(),
                    alt: "筛选",
                    class: "filter-icon"
                  }, null, 8, _hoisted_48),
                  _hoisted_49
                ], 2)
              ]),
              _: 1
            }, 8, ["visible", "getPopupContainer"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showSelectedStockInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.selectedStockCount), 1),
          _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.selectedStockDescription), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}